module.exports = __webpack_public_path__ + "img/not-found-medium-size.e960911.png";